module.exports = __webpack_public_path__ + "media/application/images/svgs/move-de73100bdf97768fca8a8f1f247923ed.svg";